<template>
  <div class="col-md-12 mb-2 rowItem row" :id="row.name">
    <div class="tools">
      <a href="#" @click.prevent="removeRow(row.name)">
        <icon name="times" />
      </a>
    </div>
    <component
      v-for="control in row.controls"
      :is="CONTROL_TYPES[control.type].source.template"
      :key="control.name"
      :control="control"
      :gridId="gridId"
      :rowData="rowData"
      @dblclick.native="openConfig(control)"
      :ref="control.name"
      :label-position="labelPosition"
      :style="control.invisible && { opacity: .5 }"
      class="control-row"
    ></component>
    <AddColumnModal
      v-if="gridId"
      :gridId="gridId"
      :rowIndex="rowIndex"
      :sectionIndex="sectionIndex"
      ref="addColumnModal"
      @columnAdded="updateForm"
    />
  </div>
</template>

<script>
import { FORM_CONSTANTS } from '@/components/DataGrid/FormBuilder/config/constants'
import { CONTROL_TYPES } from '@/components/DataGrid/FormBuilder/config/control_constant'
import {
  eventBus,
  EventHandlerConstant,
} from '@/components/DataGrid/FormBuilder/template/handler/event_handler'
import { Hooks } from '@/components/DataGrid/FormBuilder/template/components/hook_lists'
import { ControlHandler } from '@/components/DataGrid/FormBuilder/template/handler/control_handler'

import { mapState } from 'vuex'
import { findIndex, cloneDeep } from 'lodash'
// services
import db from '@/services/db'
// components
import AddColumnModal from '@/components/DataGrid/modals/AddColumn'

export default {
  name: 'row-item',
  props: {
    row: {
      type: Object,
      default: {},
    },
    rowData: {
      type: Object
    },
    labelPosition: null,
    rowIndex: {
      type: Number
    },
    sectionIndex: {
      type: Number
    }
  },
  components: {
    AddColumnModal,
  },
  data: () => ({
    CONTROL_TYPES,
    editing_control: null,
    gridId: null,
    lastAddedIndex: null,
  }),
  computed: {
    ...mapState(['dataGrid_options']),
  },
  methods: {
    moveControl(oldRowId, newRowId, controlName) {
      if (!oldRowId || !newRowId || !controlName) return
      if (oldRowId === newRowId) return
      let parentInst = this

      while (!$(parentInst.$el).hasClass('form-builder-template')) {
        parentInst = parentInst.$parent
      }

      const oldSectionId = oldRowId.split('_row')[0]
      const newSectionId = newRowId.split('_row')[0]

      const oldSection = _.find(parentInst.form.sections, {
        name: oldSectionId,
      })
      const newSection = _.find(parentInst.form.sections, {
        name: newSectionId,
      })

      const oldRow = _.find(oldSection.rows, { name: oldRowId })
      const newRow = _.find(newSection.rows, { name: newRowId })

      const newControl = _.cloneDeep(
        _.find(oldRow.controls, { name: controlName })
      )
      const oldControlIndex = _.findIndex(oldRow.controls, {
        name: controlName,
      })

      oldRow.controls.splice(oldControlIndex, 1)

      newRow.controls.push(newControl)
    },
    /* add control backup

    addControl(controlType) {
      var controlInfo = _.cloneDeep(FORM_CONSTANTS.Control)
      controlInfo.type = controlType
      // generate id
      controlInfo.name = _.domUniqueID(`control_${controlType}_`)
      controlInfo.label = FORM_CONSTANTS.Type[controlType].label
      controlInfo.fieldName = controlInfo.name // same for both

      // check if there's any more special fields?
      if (CONTROL_TYPES[controlType].other_properties) {
        _.each(CONTROL_TYPES[controlType].other_properties, (value, key) => {
          controlInfo[key] = value
        })
      }

      // before hook
      let b4Run = Hooks.Control.beforeAdd.runSequence(controlInfo, this.row)
      if (b4Run === false) {
        return
      }

      // add to row
      this.row.controls.push(controlInfo)

      // after hook
      Hooks.Control.afterAdd.run(controlInfo, this.row)
    },

    */

    addControl(controlType, index = null) {
      let type

      switch (controlType) {
        case 'text':
          type = 'string'
          break
        case 'datepicker':
          type = 'date'
          break
        default:
          type = controlType
      }

      if (this.$refs.addColumnModal) this.$refs.addColumnModal.open(type, index)
    },
    removeRow(rowName) {
      this.$emit('removeRow', rowName)
    },
    sortAfterNewControlAdded(index) {
      setTimeout(() => {
        const allElements = $('.control-row')

        const oldEl = $(allElements[index])
        const newEl = $(allElements[allElements.length - 1])

        if (!newEl.is(':empty')) {
          newEl.addClass('ui-droppable')
          newEl.insertBefore(oldEl)
          this.traverseControl()
        }
        this.lastAddedIndex = null
      }, 10)
    },
    traverseControl() {
      this.$nextTick(() => {
        let self = this

        // prepare data
        var items = $(this.$el).find('.controlItem')
        var finalItems = []

        // sort
        _.each(items, (item, index) => {
          var id = $(item).attr('id')
          var controlItem = _.find(self.row.controls, { name: id })
          controlItem.order = index
          finalItems.push(controlItem)
        })

        // reset the current sections
        this.row.controls = finalItems
      })
    },
    // control
    openConfig(controlInfo) {
      ControlHandler.clearSelect()
      ControlHandler.setSelect(controlInfo.name)
      this.editing_control = controlInfo
      Object.assign(controlInfo, {gridId: this.gridId})
      eventBus.$emit(
        EventHandlerConstant.ACTIVATE_EDITOR_SIDEBAR,
        _.cloneDeep(controlInfo)
      )
    },
    updateForm() {
      this.$nextTick(() => {
        const modalInst = this.$instByClass(this, 'editFormDataModal')
        modalInst.formData = JSON.parse(
          this.dataGrid_options[this.gridId].rowEditorFieldsForm
        )
        this.sortAfterNewControlAdded(this.lastAddedIndex)
      })
    },
    updateControlBus(control) {
      //var oldControl = _.find(this.row.controls, {name: control.name});
      let controlIndex = _.findIndex(this.row.controls, { name: control.name })

      if (
        controlIndex <= -1 ||
        this.row.controls[controlIndex].name !== (this.editing_control && this.editing_control.name)
      ) {
        return
      }

      let oldControl = this.row.controls[controlIndex]
      // check if existed name in this section
      if (
        control.fieldName !== oldControl.fieldName &&
        ControlHandler.isControlNameExisted(this.row.name, control.fieldName)
      ) {
        const message = 'This field Name is already existed in the current section.'

        this.$bvToast.toast(message, {
          title: 'Error!',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 2500,
        })

        return
      }

      // replace value
      var controlInfo = _.cloneDeep(control)
      _.each(controlInfo, (value, key) => {
        this.row.controls[controlIndex][key] = value
      })

      // update gui for specific control
      if (this.$refs[controlInfo.name]) {
        if (_.isFunction(this.$refs[controlInfo.name].configUpdated)) {
          this.$refs[controlInfo.name].configUpdated()
        }
      }

      // replace
      this.$nextTick(() => {
        ControlHandler.setSelect(oldControl.name)
      })
    }
  },
  created() {
    let self = this

    /* remove control bus backup

      // remove control bus
      eventBus.$on(EventHandlerConstant.REMOVE_CONTROL, ui => {
        // prepare data
        var id = ui.helper.attr('data-control-name');
        var controlIndex = _.findIndex(this.row.controls, {name: id});

        if (controlIndex < 0) {
          return;
        }

        // before hook
        var controlInfo = this.row.controls[controlIndex];
        let beforeRun = Hooks.Control.beforeRemove.runSequence(controlInfo);
        if (beforeRun === false) {
          return;
        }

        // remove control
        this.row.controls.splice(controlIndex, 1);

        // after hook
        Hooks.Control.afterRemove.run(controlInfo);
      });

      */

    eventBus.$off(EventHandlerConstant.REMOVE_CONTROL)

    eventBus.$on(EventHandlerConstant.REMOVE_CONTROL, ui => {
      // prepare data
      var id = ui.helper.attr('data-control-name')
      var controlIndex = _.findIndex(this.row.controls, { name: id })

      if (controlIndex < 0) {
        return
      }

      // before hook
      var controlInfo = this.row.controls[controlIndex]

      if (confirm('Are you sure?')) {
        const fbInst = this.$instByClass(this, 'form-builder-root')
        const gridId = fbInst.gridId
        const cellKey = controlInfo.propName
        const cellMeta = this.dataGrid_options[gridId].meta[cellKey]
        const view = fbInst.view
        const form = cloneDeep(fbInst.form)

        if (cellMeta && cellMeta.inherited) {
          const data = {
            gridId,
            cellKey,
            view,
            value: true,
            form,
          }

          for (let section of form.sections || []) {
            for (let row of section.rows || []) {
              const idx = findIndex(row.controls || [], { propName: cellKey })

              if (idx) {
                row.controls[idx].invisible = true

                break
              }
            }
          }

          const modalInst = this.$instByClass(this, 'editFormDataModal')

          modalInst.formData = form

          db.dataGrid.options.changeColumnVisability(data)
        } else {
          for (let section of form.sections || []) {
            for (let row of section.rows || []) {
              const idx = findIndex(row.controls || [], { propName: cellKey })

              if (~idx) {
                row.controls.splice(idx, 1)

                break
              }
            }
          }

          const modalInst = this.$instByClass(this, 'editFormDataModal')

          modalInst.formData = form

          db.dataGrid.data.removeColumn(gridId, cellKey)
        }
      }
    })

    // update control bus
    eventBus.$off(EventHandlerConstant.ON_APPLY_EDITOR_SIDEBAR, this.updateControlBus)
    eventBus.$on(EventHandlerConstant.ON_APPLY_EDITOR_SIDEBAR, this.updateControlBus)
  },
  mounted() {
    let self = this
    const fbInst = this.$instByClass(this, 'form-builder-root')
    this.gridId = fbInst.gridId

    $(this.$el).droppable({
      accept: '.control-wrapper',
      drop: function(event, ui) {
        const overElement = $('.over')
        self.lastAddedIndex = $('.control-row').index(overElement)

        self.addControl($(ui.draggable[0]).attr('data-control-type'))
        $('.over').removeClass('over')
      },
    })

    $('.control-row').droppable({
      accept: '.control-wrapper',
      over: function(event, ui) {
        ui.helper.css('border', '1px solid green')
        $(this).addClass('over')
      },
      out: function() {
        $(this).removeClass('over')
      },
    })

    $('.controlItemWrapper').droppable({
      onDragEnter: function() {
        $(this).addClass('over')
      },
      onDragLeave: function() {
        $(this).removeClass('over')
      },
    })

    $(this.$el)
      .sortable({
        cursor: 'move',
        delay: 100,
        helper: 'clone',
        connectWith: '.rowItem',
        update: function(event, ui) {
          self.traverseControl()
          self.moveControl(
            $(ui.sender).attr('id'),
            $(event.target).attr('id'),
            ui.item.data('control-name')
          )
        },
        over: function(event, ui) {
          $(this).addClass('_over')
        },
        out: function(event, ui) {
          $(this).removeClass('_over')
        },
      })
      .disableSelection()
  },
}
</script>

<style lang="scss" scoped>
.rowItem {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.03);
  padding: 30px 10px;
  margin: 0;
  position: relative;
}

.rowItem .tools {
  position: absolute;
  top: 3px;
  right: 12px;
}

.clickable {
  cursor: pointer;
}

.over {
  margin-top: 80px;
}
</style>
